(function () {
  if (window.baselayerProductsReady) return;
  window.baselayerProductsReady = true;

  const updateNav = (column, slick) => {
    if (!slick) return;
    const visible = slick.options.slidesToShow || 1;
    const total = slick.slideCount || 1;
    const canPage = total > visible;
    column.classList.toggle('is-static', !canPage);

    const prev = column.querySelector('[data-dir="prev"]');
    const next = column.querySelector('[data-dir="next"]');
    const infinite = slick.options.infinite !== false;
    const index = slick.currentSlide || 0;
    const lastIndex = Math.max(total - visible, 0);

    if (prev) {
      prev.disabled = !canPage || (!infinite && index <= 0);
      prev.classList.toggle('slick-disabled', prev.disabled);
    }
    if (next) {
      next.disabled = !canPage || (!infinite && index >= lastIndex);
      next.classList.toggle('slick-disabled', next.disabled);
    }
  };

  const initColumn = (column) => {
    if (!column || column.dataset.productsReady === 'true') return;
    if (!window.jQuery || !window.jQuery.fn || !window.jQuery.fn.slick) return;

    const slider = column.querySelector('[data-slider]');
    if (!slider) return;

    const $slider = window.jQuery(slider);
    const count = $slider.children().length;
    if (!count) return;

    column.dataset.productsReady = 'true';
    const desktopShow = Math.min(2, count);
    const prev = column.querySelector('[data-dir="prev"]');
    const next = column.querySelector('[data-dir="next"]');

    if (prev) prev.addEventListener('click', () => $slider.slick('slickPrev'));
    if (next) next.addEventListener('click', () => $slider.slick('slickNext'));

    $slider.on('init afterChange setPosition breakpoint', function (event, slick) {
      updateNav(column, slick);
    });

    $slider.slick({
      infinite: true,
      draggable: true,
      arrows: false,
      dots: true,
      slidesToShow: desktopShow,
      slidesToScroll: 1
    });
  };

  const boot = (scope) => {
    const context = scope && scope.querySelectorAll ? scope : document;
    context.querySelectorAll('[data-baselayer-column]').forEach(initColumn);
    if (context.matches && context.matches('[data-baselayer-column]')) initColumn(context);
  };

  const whenSlickReady = (callback) => {
    if (window.jQuery && window.jQuery.fn && window.jQuery.fn.slick) {
      callback();
      return;
    }
    const timer = window.setInterval(() => {
      if (window.jQuery && window.jQuery.fn && window.jQuery.fn.slick) {
        window.clearInterval(timer);
        callback();
      }
    }, 50);
    window.setTimeout(() => window.clearInterval(timer), 8000);
  };

  whenSlickReady(() => boot(document));
  document.addEventListener('shopify:section:load', (event) => {
    whenSlickReady(() => boot(event.target));
  });
})();
